import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import "react-placeholder/lib/reactPlaceholder.css";

import Aux from "./components/utility/Aux";
import TopBar from "./components/topbar/TopBar";

import Main from "./components/main/Main";
import Start from "./modules/Start";

import "./stylesheets/App.css";
import "./stylesheets/themed/dark.css";

import PageNotFound from "./errors/PageNotFound";
import Login from "./modules/Login";

import Dashboard from "./modules/dashboard/Dashboard";
import Settings from "./modules/settings/Settings";
import Organizer from "./modules/organizer/Organizer";
import Document from "./modules/Document";

import Wizards from "./routes/Wizards";
import UserRoute from "./routes/UserRoute";

/**
 * App: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * App component which renders the entire Application UI
 * and switches based on routes.
 *
 * @param {*} props
 */
const App = ({ location, currentTheme }) => (
  <Router>
    <div className={`main-ui theme-${currentTheme}`}>
      <Aux>
        <div className="ui">
          <Route path="/:active?" component={TopBar} />
          <Main>
            <Switch>
              <Route location={location} exact path="/" component={Start} />
              <Route
                location={location}
                exact
                path="/login"
                component={Login}
              />
              <UserRoute
                location={location}
                exact
                path="/organizer"
                component={Organizer}
              />
              <UserRoute
                location={location}
                exact
                path="/agenda"
                component={Dashboard}
              />
              <UserRoute
                location={location}
                path="/settings"
                component={Settings}
              />
              <UserRoute
                location={location}
                path="/document"
                component={Document}
              />
              <UserRoute
                location={location}
                path="/create"
                component={Wizards}
              />
              <Route location={location} component={PageNotFound} />
            </Switch>
          </Main>
        </div>
      </Aux>
    </div>
  </Router>
);

const mapStateToProps = state => ({
  currentTheme: state.settings.theme || "dark"
});

App.propTypes = {
  /**
   * location: Object
   * Location object which holds the current navigator location
   * for routing
   */
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired,
  /**
   * currentTheme: String
   * Currently selected theme identifier
   */
  currentTheme: PropTypes.string.isRequired
};

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js